







































import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

@Component
export default class PredictDataStatisticsNa extends Vue {
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    public get predictDataStatistics(): any[] {
        return sessionModule.getPredictDataStatistics;
    }
}
